<div class="event-material" [attr.data-cy]="'material-file-' + item.id">
  <lib-file-icon class="file-icon" [file]="item" [size]="24"></lib-file-icon>

  <span class="file-name" ellipsis [ellipsis-content]="item.filename || item.name" data-cy="material-file-name"></span>

  @if (previewEnabled) {
    <button
      mat-icon-button
      class="button button--icon button--icon-extra-small"
      [matTooltip]="'COMMON.preview' | translate"
      matTooltipClass="dark-tooltip"
      (click)="openFile()"
      data-cy="material-preview-file"
      aria-label="Preview file">
      <lib-icon icon="eye"></lib-icon>
    </button>
  }

  @if (downloadEnabled) {
    <button
      mat-icon-button
      class="button button--icon button--icon-extra-small"
      [matTooltip]="'COMMON.download' | translate"
      matTooltipClass="dark-tooltip"
      (click)="downloadFile()"
      data-cy="material-download-file"
      aria-label="Download file">
      <lib-icon icon="download-simple"></lib-icon>
    </button>
  }

  @if (deleteEnabled) {
    <button
      mat-icon-button
      class="button button--icon button--icon-extra-small"
      [matTooltip]="'COMMON.delete' | translate"
      matTooltipClass="dark-tooltip"
      (click)="deleteFile()"
      aria-label="Delete file"
      data-cy="material-delete-file">
      <lib-icon icon="trash"></lib-icon>
    </button>
  }
</div>
